<template>
    <li :class="{
        'custom-treeview-node--leaf': !this.hasChildren,
        'custom-treeview-node--click': this.openOnClick,
        'custom-treeview-node--disabled': this.disabled,
        'custom-treeview-node--rounded': this.rounded,
        'custom-treeview-node--shaped': this.shaped,
        'custom-treeview-node--selected': this.isSelected,
        'custom-treeview-node--excluded': this.treeview.isExcluded(this.key),
        }" :data-parent-key="this.treeview.getParent(this.key)">

        <div class="d-flex align-items-center">
            <div class="custom-treeview-node-wrapper d-flex align-items-center" :class="{'custom-treeview-node-hover': onHoverAction}">
                <md-arrow-right-icon v-if="!isOpen && item.children && Array.isArray(item.children) && item.children.length" v-model="isOpen" @click.native="onToggle($event)"/>
                <md-arrow-down-icon v-else-if="isOpen && item.children && Array.isArray(item.children) && item.children.length" v-model="isOpen" @click.native="onToggle($event)"/>
                <div v-else class="input-spacer" style="width: 24px;height: 24px;"></div>
                <mdb-input v-if="showCheckBox" type="checkbox" v-model="isSelected" class="" :inner-value="item[this.itemKey]" :input-checked="isSelected" @click.native="onCheck($event)"/>
                <span class="custom-treeview-node-text" :class="itemTextClass" :style="itemTextStyle">
                    <div v-if="showValueText">{{ (item[this.itemValueText] ? item[this.itemValueText] : '') + ' : ' + (item[this.itemText] ? item[this.itemText] : '') }}</div>
                    <div v-if="!showValueText">{{ (item[this.itemText] ? item[this.itemText] : '') }}</div>
                </span>

                <div v-if="showEditColumn" class="editor-column" :style="editColumnStyle">
                    <ul class="editor-btns d-flex align-items-center" style="list-style: none;">
                        <li v-if="showAddButton" :data-parent-key="this.treeview.getParent(this.key)" :data-key="this.key">
                            <div>
                                <div class="">
                                    <button type="button" class="btn old-btn btn-sm center-icon-btn role-edit-btn ml-10px" data-toggle="modal" :data-target="'#tree-node-add-' + this.key" style="width: 55px;">
                                        <gd-add-item-icon class="icon-btn-15"></gd-add-item-icon>
                                        <span>追加</span>
                                    </button>
                                    <form class="modal fade" :id="'tree-node-add-' + this.key" tabindex="-1" role="dialog" :aria-labelledby="'tree-node-add-label-' + this.key" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 330px;">
                                            <div class="modal-content">
                                                <div class="modal-header">
<!--                                                    <h5 class="modal-title" :id="'tree-node-add-label-' + this.key">{{ item[this.itemText] }}の子を新規登録</h5>-->
                                                    <h5 class="modal-title" :id="'tree-node-add-label-' + this.key">{{ item[this.itemText] }}の下層を新規登録</h5>
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    <div class="col-12 mb-10px">
                                                        <label class="mb-1">コード (給与計算ソフトと同一コード)</label>
                                                        <input type="text" class="form-control treenode-value" name="tree_node_value" placeholder="半角英数字"/>
                                                    </div>
                                                    <div class="col-12 mb-10px">
                                                        <label class="mb-1">名称 (給与計算ソフトと同一名称)</label>
                                                        <input type="text" class="form-control treenode-name" name="tree_node_name"/>
                                                    </div>
                                                    <div class="col-12">
                                                        <label class="mb-1">表示順</label>
                                                        <input type="text" class="form-control treenode-sortno text-right" name="tree_node_sort_no" :value="0" required/>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button @click="onAddButtonClick" type="button" class="btn old-btn center-icon-btn">
                                                        <gd-do-save-icon class="icon-btn-15"></gd-do-save-icon>
                                                        <span>保存</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </li>
                        <li v-if="showEditButton && this.key!==0" :data-parent-key="this.treeview.getParent(this.key)" :data-key="this.key">
                            <div>
                                <div class="">
                                    <button type="button" class="btn old-btn btn-sm center-icon-btn role-edit-btn ml-10px" data-toggle="modal" :data-target="'#tree-node-edit-' + this.key" style="width: 55px;">
                                        <gd-edit-item-icon class="icon-btn-15"></gd-edit-item-icon>
                                        <span>編集</span>
                                    </button>
                                    <form class="modal fade" :id="'tree-node-edit-' + this.key" tabindex="-1" role="dialog" :aria-labelledby="'tree-node-add-label-' + this.key" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 330px;">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title" :id="'tree-node-edit-label-' + this.key">{{ item[this.itemText] }}の名称を更新</h5>
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    <div class="col-12">
                                                        <label>コード</label>
                                                        <input type="text" class="form-control treenode-value" name="tree_node_value" :value="item[this.itemValueText]"/>
                                                    </div>
                                                    <div class="col-12">
                                                        <label>名称</label>
                                                        <input type="text" class="form-control treenode-name" name="tree_node_name" :value="item[this.itemText]"/>
                                                    </div>
                                                    <div class="col-12">
                                                        <label>表示順</label>
                                                        <input type="text" class="form-control treenode-sortno text-right" name="tree_node_sort_no" :value="item['sort_no'] ? item['sort_no'] : 0" required/>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button @click="onEditButtonClick" type="button" class="btn old-btn center-icon-btn">
                                                        <gd-do-save-icon class="icon-btn-15"></gd-do-save-icon>
                                                        <span>保存</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </li>
                        <li v-if="showRemoveButton && this.key!==0" :data-parent-key="this.treeview.getParent(this.key)" :data-key="this.key">
                            <div>
                                <div class="">
                                    <button type="button" @click="onRemoveButtonClick" class="btn old-btn btn-sm center-icon-btn role-remove-btn ml-10px" style="width: 55px;">
                                        <gd-remove-item-icon class="icon-btn-15"></gd-remove-item-icon>
                                        <span>削除</span>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
        <ul v-if="isOpen" style="list-style: none;padding-inline-start:0;padding-left:40px;">
            <custom-tree-node
                    class="item"
                    v-for="(child, index) in item.children"
                    :key="index"
                    :item="child"
                    :item-text="itemText"
                    :item-key="itemKey"
                    :show-value-text="showValueText"
                    :item-disabled="itemDisabled"
                    :edit-column-style="editColumnStyle"
                    :show-edit-column="showEditColumn"
                    :show-add-button="showAddButton"
                    :show-edit-button="showEditButton"
                    :show-remove-button="showRemoveButton"
                    :show-check-box="showCheckBox"
                    :item-text-class="itemTextClass"
                    :item-text-style="itemTextStyle"
                    :on-hover-action="onHoverAction">
            </custom-tree-node>
        </ul>
    </li>
</template>

<script>
    import MdArrowLeftIcon from "../../core/icons/MdArrowLeftIcon";
    import MdArrowRightIcon from "../../core/icons/MdArrowRightIcon";
    import MdArrowDownIcon from "../../core/icons/MdArrowDownIcon";
    import MdCheckbox from "../../components/MdCheckbox/MdCheckbox";
    import mdbInput from "../../../CustomMDBVue/Forms/Input.vue"
    import GdAddItemIcon from "../Common/icons/GdAddItemIcon";
    import GdEditItemIcon from "../Common/icons/GdEditItemIcon";
    import GdRemoveItemIcon from "../Common/icons/GdRemoveItemIcon";
    import GdDoSaveIcon from "../Common/icons/GdDoSaveIcon";

    export default {
        name: "CustomTreeNode",
        components: {
            GdDoSaveIcon,
            GdRemoveItemIcon,
            GdEditItemIcon,
            GdAddItemIcon,
            MdArrowLeftIcon,
            MdArrowRightIcon,
            MdArrowDownIcon,
            MdCheckbox,
            mdbInput
        },
        inject: {
            treeview: {default: null}
        },
        model: {
            prop: 'isSelected',
            event: 'click'
        },
        props: {
            item: {
                type: Object,
                default: () => null,
            },
            activatable: Boolean,
            activeClass: {
                type: String,
                default: 'v-treeview-node--active',
            },
            color: {
                type: String,
                default: 'primary',
            },
            expandIcon: {
                type: String,
                default: '$subgroup',
            },
            indeterminateIcon: {
                type: String,
                default: '$checkboxIndeterminate',
            },
            itemChildren: {
                type: String,
                default: 'children',
            },
            itemDisabled: {
                type: String,
                default: 'false',
            },
            itemKey: {
                type: String,
                default: 'id',
            },
            itemValueText: {
                type: String,
                default: 'value',
            },
            itemText: {
                type: String,
                default: 'name',
            },
            loadChildren: Function,
            loadingIcon: {
                type: String,
                default: '$loading',
            },
            offIcon: {
                type: String,
                default: '$checkboxOff',
            },
            onIcon: {
                type: String,
                default: '$checkboxOn',
            },
            openOnClick: Boolean,
            rounded: Boolean,
            selectable: Boolean,
            selectedColor: {
                type: String,
                default: 'accent',
            },
            shaped: Boolean,
            transition: Boolean,
            editColumnStyle: {
                type: Array,
                default: () => [{'width':'380px','min-width':'380px'}]
            },
            showEditColumn: {
                type: Boolean,
                default: false,
            },
            showAddButton: {
                type: Boolean,
                default: true,
            },
            showEditButton: {
                type: Boolean,
                default: true,
            },
            showRemoveButton: {
                type: Boolean,
                default: true,
            },
            showCheckBox: {
                type: Boolean,
                default: true,
            },
            onHoverAction: {
                type: Boolean,
                default: false,
            },
            itemTextClass: {
                type: Array,
                default: () => ([]),
            },
            itemTextStyle: {
                type: Array,
                default: () => ([]),
            },
            showValueText:{
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                hasLoaded: false,
                isActive: false,
                isIndeterminate: false,
                isLoading: false,
                isOpen: false,
                isSelected: this.selected,
            }
        },

        watch: {
            // isSelected(){
            // }
        },

        computed: {
            disabled() {
                return this.getObjectValueByPath(this.item, this.itemDisabled, false)
            },
            key() {
                return this.getObjectValueByPath(this.item, this.itemKey, null)
            },
            children() {
                return this.getObjectValueByPath(this.item, this.itemChildren, [])
            },
            text() {
                return this.getObjectValueByPath(this.item, this.itemText, '')
            },
            scopedProps() {
                return {
                    item: this.item,
                    leaf: !this.children,
                    selected: this.isSelected,
                    indeterminate: this.isIndeterminate,
                    active: this.isActive,
                    open: this.isOpen,
                }
            },
            computedIcon() {
                if (this.isIndeterminate) return this.indeterminateIcon;
                else if (this.isSelected) return this.onIcon;
                else return this.offIcon
            },
            hasChildren() {
                return !!this.children && (!!this.children.length || !!this.loadChildren)
            },
        },

        created() {
            this.treeview.register(this);
        },

        mounted() {
        },

        beforeDestroy() {
            this.treeview.unregister(this);
        },

        methods: {
            getObjectValueByPath(obj, path, fallback = {}) {
                if (obj == null || !path || typeof path !== 'string') return fallback;
                if (obj[path] !== undefined) return obj[path];
                path = path.replace(/\[(\w+)\]/g, '.$1');
                path = path.replace(/^\./, '');
                return this.getNestedValue(obj, path.split('.'), fallback)
            },
            getNestedValue(obj, path, fallback = {}) {
                const last = path.length - 1
                if (last < 0) return obj === undefined ? fallback : obj
                for (let i = 0; i < last; i++) {
                    if (obj == null) {
                        return fallback
                    }
                    obj = obj[path[i]]
                }
                if (obj == null) return fallback

                return obj[path[last]] === undefined ? fallback : obj[path[last]]
            },
            checkChildren() {
                return new Promise(resolve => {
                    // TODO: Potential issue with always trying
                    // to load children if response is empty?
                    if (!this.children || this.children.length || !this.loadChildren || this.hasLoaded) return resolve()

                    this.isLoading = true
                    resolve(this.loadChildren(this.item))
                }).then(() => {
                    this.isLoading = false
                    this.hasLoaded = true
                })
            },
            open() {
                this.isOpen = !this.isOpen
                this.treeview.updateOpen(this.key, this.isOpen)
                this.treeview.emitOpen()
            },
            onToggle(event) {
                if (this.disabled) return

                event.stopPropagation()

                if (this.isLoading) return

                this.checkChildren().then(() => this.open())
            },
            onCheck(event) {
                if (this.disabled) return

                event.stopPropagation()

                if (this.isLoading) return

                this.checkChildren().then(() => {
                    // We nextTick here so that items watch in VTreeview has a chance to run first
                    this.$nextTick(() => {
                        this.isSelected = !this.isSelected
                        this.isIndeterminate = false

                        if (this.treeview.multiple && this.treeview.selectAll === false) {
                            if (this.key === 0) {
                                //全社の場合
                                if (this.isSelected) {
                                    //全社をチェック->他のチェックを外す
                                    const newKeys = this.treeview.getKeys(this.treeview.itemdata);
                                    for (let i = 0; i < newKeys.length; i++) {
                                        let key = newKeys[i];
                                        if (key !== this.key) {
                                            this.treeview.updateSelected(key, false);
                                        } else {
                                            this.treeview.updateSelected(key, true);
                                        }
                                    }
                                    this.treeview.emitSelected();
                                } else {
                                    //全社のチェックを外す
                                    this.treeview.updateSelected(this.key, this.isSelected);
                                    this.treeview.emitSelected()
                                }
                            } else {
                                //全社以外の場合
                                this.treeview.updateSelected(this.key, this.isSelected);    //選択した項目の更新
                                this.treeview.updateSelected(0, false);                     //全社のチェックを外す
                                this.treeview.emitSelected();
                            }

                        } else {
                            this.treeview.updateSelected(this.key, this.isSelected);
                            this.treeview.emitSelected()
                        }
                    })

                });

            },
            onAddButtonClick(event) {
                this.treeview.onAddButtonClick(event);
            },
            onEditButtonClick(event) {
                this.treeview.onEditButtonClick(event);
            },
            onRemoveButtonClick(event) {
                this.treeview.onRemoveButtonClick(event);
            },
            log(msg, obj = "") {
                console.log(msg, obj);
            }
        }

    }
</script>

<style scoped lang="scss">

    .custom-treeview .form-check {
        padding-left: 0;
        display: flex;
        align-items: center;
    }

    .custom-treeview .input-spacer {
        width: 24px;
        height: 24px;
    }

</style>

<style lang="scss">
    .custom-treeview {
        .form-check-input[type=checkbox] + label {
            padding-left: 24px;
        }

        li .custom-treeview-node-wrapper.custom-treeview-node-hover:hover {
            background-color: #deebf7;
        }

        .custom-treeview-node-wrapper>i>svg{
            cursor: pointer;
        }

        .md-icon{
            min-width: 15px;
        }
    }

</style>
